import QRCode from 'qrcode';
import { Mold } from '../types';

export interface QRData {
  moldId: string;
  moldNumber: string;
  type: 'mold';
  version: '1.0';
}

export class QRService {
  // QR코드 데이터 생성
  static generateQRData(mold: { id?: string; moldNumber: string }): QRData {
    return {
      moldId: mold.id || 'temp-' + Date.now(),
      moldNumber: mold.moldNumber,
      type: 'mold',
      version: '1.0'
    };
  }

  // QR코드 문자열 생성 (JSON)
  static createQRString(qrData: QRData): string {
    return JSON.stringify(qrData);
  }

  // QR코드 이미지 생성 (Base64)
  static async generateQRImage(qrString: string): Promise<string> {
    try {
      const options = {
        width: 512,  // 256 → 512 (크기 증가)
        margin: 4,   // 2 → 4 (마진 증가)
        errorCorrectionLevel: 'H' as const,  // 에러 보정 레벨 최대
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      };
      return await QRCode.toDataURL(qrString, options);
    } catch (error) {
      console.error('QR 코드 생성 실패:', error);
      throw new Error('QR 코드 생성에 실패했습니다.');
    }
  }

  // QR코드 데이터 파싱
  static parseQRData(qrString: string): QRData {
    try {
      console.log('🔍 QR 원본 문자열:', qrString);
      const data = JSON.parse(qrString);
      console.log('🔍 JSON 파싱 결과:', data);
      
      if (!data.moldId || !data.moldNumber || data.type !== 'mold') {
        console.error('❌ 유효하지 않은 QR 형식:', data);
        throw new Error('유효하지 않은 QR 코드 형식입니다.');
      }
      console.log('✅ QR 데이터 검증 성공:', data);
      return data as QRData;
    } catch (error) {
      console.error('❌ QR 데이터 파싱 실패:', error);
      throw new Error('QR 코드를 읽을 수 없습니다.');
    }
  }

  // 금형에 QR 데이터 추가
  static addQRDataToMold(mold: Mold): Mold {
    const qrData = this.generateQRData(mold);
    const qrString = this.createQRString(qrData);
    
    return {
      ...mold,
      qrCode: qrString
    };
  }
}
